import recommending from '@PROJECT_ROOT/assets/mobile/js/recommending';

global.recommending = recommending;
